import { useSnapshot } from 'valtio';

import { FileUploader } from '@cartwhl/ui/feature/FileUploader';
import Button from '@cartwhl/ui/input/Button';

import { animationGenerationStore, navigationStore } from 'stores';

import { MAX_FILE_SIZE, VIDEO_EXTENSIONS } from '../constants';

export default function VideoUploadModal({ close }: { close: () => void }) {
  const { videoUpload } = useSnapshot(animationGenerationStore.state);

  return (
    <div className="h-1/2">
      <FileUploader
        fileContent="Video"
        accept={{ 'application/octet-stream': VIDEO_EXTENSIONS }}
        cancelable={true}
        maxFileSize={MAX_FILE_SIZE}
        upload={videoUpload}
        onCancel={(uploadID: string) => {
          animationGenerationStore.deleteJobFromBackend(uploadID);
        }}
        onDrop={(file) => animationGenerationStore.beginVideoUpload(file)}
        onRemove={() => {
          animationGenerationStore.removeUpload();
          navigationStore.setModal('');
        }}
      />

      {!videoUpload && (
        <div className="mt-6">
          <Button onClick={close}>Cancel</Button>
        </div>
      )}
    </div>
  );
}
